<template>
  <div id="home" class="home">
    <Header />
    <div class="container">
      <div class="title">
        <h1>物联网平台<span class="version">{{ version }}</span></h1>
        <h2>AIoT Platform</h2>
      </div>
      <div
        id="nav"
        class="nav"
        :style="{ gridTemplateRows: `repeat(${rows}, 1fr)`, gridTemplateColumns: `repeat(${columns}, 1fr)`, height: `${navWidth}px` }"
      >
        <template v-for="item in navList">
          <div
            v-if="item.visible"
            :key="item.id"
            :class="'nav-block'"
            :style="{
              gridRowStart: item.rowStart,
              gridRowEnd: item.rowStart + item.row,
              gridColumnStart: item.colStart,
              gridColumnEnd: item.colStart + item.col
            }"
          >
            <div
              :class="['nav-item', { 'no-permission': hasPermission(item.id), 'flex-row': item.col > item.row }]"
              @click="handleRouter(item)"
            >
              <svg-icon :class="['nav-icon', { 'beacon': item.icon === 'beacon' }]" :icon-class="item.icon" />
              <b class="nav-name">{{ item.name }}</b>
              <div v-if="hasPermission(item.id)" class="lock">
                <svg-icon class="lock-icon" icon-class="lock" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { filterVersion } from '@/utils/index'
import Header from '@/components/Header'

export default {
  name: 'Home',
  components: {
    Header
  },
  data() {
    return {
      code: ['02', '0802', '03', '04', '05', '-1', '07', '01'],
      routerTag: [3, 4, 7],
      info: JSON.parse(sessionStorage.getItem('info')),
      navWidth: 0,
      rows: 2,
      columns: 6,
      navList: [{
        id: 0,
        name: '瞭望塔',
        visible: false,
        icon: 'watchtower',
        rowStart: 1,
        row: 2,
        colStart: 1,
        col: 2,
        url: process.env.VUE_APP_BEIDOU_URL
      }, {
        id: 1,
        name: '烽火台',
        visible: false,
        icon: 'beacon',
        rowStart: 1,
        row: 2,
        colStart: 1,
        col: 2,
        url: process.env.VUE_APP_BEACON_URL
      }, {
        id: 2,
        name: 'IoT平台',
        visible: true,
        icon: 'platform',
        rowStart: 1,
        row: 2,
        colStart: 1,
        col: process.env.VUE_APP_MODE === 'overseas' ? 3 : 2,
        url: process.env.VUE_APP_AIOT_URL
      }, {
        id: 3,
        name: 'W.DMS',
        visible: process.env.VUE_APP_MODE !== 'overseas',
        icon: 'softwares',
        rowStart: 1,
        row: 2,
        colStart: 3,
        col: 2,
        url: '/dms/version'
      }, {
        id: 4,
        name: 'IoT插件',
        visible: false,
        icon: 'plugins',
        rowStart: 2,
        row: 1,
        colStart: 4,
        col: 1,
        url: '/iplugin/version'
      }, {
        id: 5,
        name: '数据引擎',
        visible: false,
        icon: 'database',
        rowStart: 1,
        row: 1,
        colStart: 5,
        col: 2,
        url: '/'
      }, {
        id: 6,
        name: '开放平台',
        visible: false,
        icon: 'org',
        rowStart: 2,
        row: 1,
        colStart: 5,
        col: 2,
        url: process.env.VUE_APP_OPEN_URL
      }, {
        id: 7,
        name: '权限管理',
        visible: true,
        icon: 'user',
        rowStart: 1,
        row: 2,
        colStart: process.env.VUE_APP_MODE === 'overseas' ? 4 : 5,
        col: process.env.VUE_APP_MODE === 'overseas' ? 3 : 2,
        url: '/manage/auth'
      }],
      version: ''
    }
  },
  mounted() {
    this.version = filterVersion()
    window.onresize = () => {
      this.navWidth = parseInt(getComputedStyle(document.querySelectorAll('.nav-item')[0]).width)
    }
    this.navWidth = parseInt(getComputedStyle(document.querySelectorAll('.nav-item')[0]).width)
  },
  methods: {
    handleRouter(nav) {
      if (!this.hasPermission(nav.id) || nav.id === 3 || nav.id === 4) {
        if (this.routerTag.indexOf(nav.id) > -1) {
          this.$router.push({ path: nav.url })
        } else {
          location.href = nav.url
        }
      }
    },
    hasPermission(index) {
      let buzAuth = []
      if (this.info.buzAuth) {
        buzAuth = this.info.buzAuth
      }
      let tag = true
      for (let i = 0; i < buzAuth.length; i++) {
        if (buzAuth[i].substr(0, this.code[index].length) === this.code[index] || index === 3 || index === 4) {
          tag = false
          break
        }
      }
      return tag
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@mixin flex-column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.home {
  width: 100vw;
  height: 100vh;
  background: #00101A url("../assets/bg2.jpg") no-repeat top center;
  background-size: cover;
  overflow: hidden;
  color: #ffffff;
  @include flex-column-center;
}
.container {
  width: 100%;
  @include flex-column-center;
}
.title {
  opacity: 0.9;
  margin-bottom: 200px;

  >h1 {
    font-size: 52px;
    font-weight: 400;
    display: block;
    margin-top: 0;
    margin-bottom: 15px;
    letter-spacing: 6px;
  }

  h2 {
    font-size: 34px;
    font-weight: 200;
    letter-spacing: 5px;
    margin: 0;
  }

  .version {
    background-color: #409eff;
    color: #fff;
    font-weight: 600;
    text-align: center;
    font-size: 28px;
    letter-spacing: 0px;
    vertical-align: middle;
    position: relative;
    top: -3px;
    padding: 2px 5px;
    margin-left: 8px;
  }
}
.nav {
  width: 60%;
  display: grid;
  gap: 16px;
}
.nav-block {
  box-sizing: border-box;
  flex: 1;
  position: relative;
}
.nav-item {
  position: relative;
  width: 100%;
  height: 100%;
  @include flex-column-center;
  user-select: none;
  border-radius: 4px;
  background-color: rgba(30, 55, 85, 0.7);
  transition: transform 0.3s, background-color 0.3s;
  .nav-icon {
    width: 4rem;
    height: 4rem;
    margin-bottom: 12px;
    &.beacon {
      width: 6rem;
      height: 6rem;
      margin-bottom: 4px;
    }
  }
  .nav-name {
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2rem;
  }
  &.flex-row {
    flex-direction: row;
    .nav-icon {
      margin-right: 12px;
      margin-bottom: 0;
    }
  }
  &:not(.no-permission) {
    &:hover {
      cursor: pointer;
      background-color: rgba(0, 170, 255, 0.7);
      transform: scale(1.02);
    }
    &:active {
      transform: scale(0.98);
    }
  }
}

.no-permission {
  background-color: rgba(153, 153, 153, 0.7);
  cursor: not-allowed;
  .lock {
    width: 0;
    height: 0;
    border-top: 20px solid #ffffff;
    border-right: 20px solid #ffffff;
    border-bottom: 20px solid transparent;
    border-left: 20px solid transparent;
    position: absolute;
    top: 0;
    right: 0;
    .lock-icon {
      width: 20px;
      height: 20px;
      position: absolute;
      bottom: -2px;
      left: -2px;
    }
  }
}
</style>

<style lang="scss">
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: rgba(153, 153, 153, 0);
}

.el-menu--horizontal>.el-submenu:focus .el-submenu__title,
.el-menu--horizontal>.el-submenu:hover .el-submenu__title {
  color: #fff
}

.el-menu--horizontal>.el-submenu:focus .el-submenu__title,
.el-menu--horizontal>.el-submenu .el-submenu__title {
  color: #fff
}

.el-submenu__title i {
  color: #fff
}

.el-menu.el-menu--horizontal {
  border: none;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 90px;
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border: none;
  color: #fff;
}
</style>
